export default __webpack_public_path__ + "maps-examples-source-custom-vector-1200-02d1ccd520fbdb6969269468529a0577.webp";